/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { languages, setLanguage } from '../../helpers/utils';

function LanguageFooter() {
  const onSwitchLanguage = (language) => {
    setLanguage(language);
    window.location.reload();
  };

  return (
    <Row
      className="justify-content-between text-center"
      style={{ bottom: '0', position: 'relative' }}
    >
      <Col>
        <p className="my-5 text-600">
          {languages.map(({ caption, language }) => (
            <a
              className="opacity-50 px-1"
              href={null}
              onClick={() => onSwitchLanguage(language)}
              style={{ cursor: 'pointer' }}
              key={`language-${language}`}
            >
              {caption}
            </a>
          ))}
        </p>
      </Col>
    </Row>
  );
}

export default LanguageFooter;
